import { useEffect, useLayoutEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { SessionStorage } from 'common/CookieStorage'
import { AppStorage } from 'common/AppStograge'
import { STORAGEKEYS } from 'enviroment/Keys'
import { AppLinks } from 'enviroment/AppLinks'
import { AppDispatch, AppState } from 'store'
import { appBackOnline, appOffline, appOnline } from 'store/ApplicationSlice/ApplicationSlice'
import { reconnectOnInvalidConnection, tryReconnectToHub } from 'store/ApplicationSlice/middleware/credential.action'
import apphistory from 'common/AppHistory'


/**
 * Hook obsługujący logikę głównego komponentu aplikacji. 
 * Odpowiada m.in za połączenie z HUBem
*/
const useAppRootLogic = () => {
   const { pathname } = useLocation()
   const navigate = useNavigate()
   const dispatch = useDispatch<AppDispatch>()

   const applicationState = useSelector((state: AppState) => state.applicationState)
   const [currentLocation, setLocation] = useState("");
   const [isOnline, setIsOnline] = useState(navigator.onLine)

// >>> USE EFFECT
   useEffect(() => {
      setInterval(() => dispatch(reconnectOnInvalidConnection()), 30000)

      apphistory.listen(({ action, location }): void => {
         if (action === "PUSH") {

            if(!location.pathname.includes('houston')){
               setLocation(location.pathname)
            }

            if(location.pathname !== window.location.pathname){
               apphistory.push(location.pathname)
            }

            window.scrollTo(0,0)
         }
         else {
            apphistory.go(1)
         }
      })

      apphistory.go(1)

      const storage = new SessionStorage();
      const token = storage.get(STORAGEKEYS.ACCESS_TOKEN)
      
      if(token === null){
         const appStorage = new AppStorage()
         appStorage.clearLocalStorage()
      }

      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, []);


   useEffect(() => {
      dispatch(tryReconnectToHub())
      
   }, [applicationState, dispatch])



   useEffect(()=>{
      if(!applicationState.isOffline && applicationState.wasOffline){
         apphistory.push(currentLocation)
         dispatch(appBackOnline())
      }

   //eslint-disable-next-line react-hooks/exhaustive-deps
   }, [applicationState.isOffline])


   /**
    * Gdy użytkownik jest "offline", kierujemy go na stronę "houston" z informacją o braku internetu
    * Gdy powróci "online" kierujemy go na ostatnią stronę na której się znajdował przed przejściem offline
   */
   useEffect(() => {
     const handleOnline = () => {
       setIsOnline(true)
       navigate(-1) // Ostatnia strona na której użytkownik znajdował się przed przejścfiem offline
       dispatch(appOnline())
     };
 
     const handleOffline = () => {
       setIsOnline(false)
       navigate(AppLinks.houston)
       dispatch(appOffline())
     };

      // Użytkownik używa nawigacji przeglądarki (strzałki wstecz / dalej)
     const handlePopState = () => {
      apphistory.go(1)
     };
 
     window.addEventListener('online', handleOnline)
     window.addEventListener('offline', handleOffline)
     window.addEventListener("popstate", handlePopState)
 
     return () => {
       window.removeEventListener('online', handleOnline)
       window.removeEventListener('offline', handleOffline)
       window.removeEventListener('popstate', handlePopState)
     }

   //eslint-disable-next-line react-hooks/exhaustive-deps
   }, [navigate])

   useLayoutEffect(() => { // Wymuszamy scrollowanie do góry strony po przejściu ze strony na stronę
      window.scrollTo({
         top: 0,
         left: 0,
         //@ts-ignore
         behavior: "instant", // Optional if you want to skip the scrolling animation
      })
   }, [ pathname ])
}


export default useAppRootLogic